<mat-form-field appearance="fill" style="width: 100%; margin-bottom: 8px" class="templated-input-container">
  <mat-label>{{ label | translate: locale.language }}</mat-label>

  <textarea
    class="templated-input"
    matInput
    [formControl]="inputControl"
    [matAutocomplete]="auto"
    [errorStateMatcher]="errorMatcher"
    #inputEl
    cdkTextareaAutosize
  ></textarea>

  <button
    *ngIf="useIntegratedPreview && inputHasVariables && inputControl?.valid"
    matSuffix
    mat-icon-button
    (click)="previewInput = !previewInput"
    style="margin-right: 8px"
    matTooltip="Preview Placeholders"
    aria-label="Preview Placeholders"
  >
  
    <mat-icon color="{{ previewInput ? 'primary' : 'default' }}">visibility</mat-icon>
  </button>

  <button 
    *ngIf="showReset" 
    matSuffix
    mat-icon-button
    (click)="onResetClick()"
    style="margin-right: 8px"
    matTooltip="Reset Input"
    aria-label="Reset Input"
  >
    <mat-icon>restore</mat-icon>
  </button>

  <mat-hint *ngIf="showHint">
    <span [class]="hintClass">
      {{ hintText }}
    </span>
  </mat-hint>

  <span matTextSuffix *ngIf="readonly" class="as-error-text" style="font-size: 0.8rem">{{
    readonlyText | translate: locale.language
  }}</span>

  <mat-error *ngIf="inputControl?.hasError('unclosedBraces')">
    {{ inputControl?.getError('unclosedBraces')?.message }}
  </mat-error>

  <mat-error *ngIf="inputControl?.hasError('variableExists')">
    {{ inputControl?.getError('variableExists')?.message }}
  </mat-error>
</mat-form-field>

<mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
  <!-- Bind to the entire variable object -->
  <mat-option *ngFor="let variable of filteredVariables" [value]="variable">
    <div><strong>{{ variable.friendlyName }}</strong></div>
    <div class="text-muted"><small>Source: {{ variable.source }}</small></div>
  </mat-option>
</mat-autocomplete>

<div
  class="preview-section"
  *ngIf="useIntegratedPreview && inputHasVariables && inputControl?.valid && previewInput"
  style="margin-bottom: 16px"
>
  <div class="section-label">
    Subject Preview:
    <div style="transform: scale(0.8); transform-origin: top left; display: inline-block">
      <mat-checkbox [(ngModel)]="displayChips">Display placeholders</mat-checkbox>
      <mat-checkbox [(ngModel)]="useSample">Use sample value</mat-checkbox>
    </div>
  </div>
  <div class="chat" style="margin-top: 8px">
    <div class="yours messages">
      <div class="message last" [innerHtml]="previewHtml"></div>
    </div>
  </div>
</div>
